var __webpack_exports__ = {};
/*!************************************!*\
  !*** ./scripts/components/file.js ***!
  \************************************/
class ModuleFile extends HTMLElement {
  constructor() {
    super();
    this.file = this.querySelector('[type="file"]');
    this.fileName = this.querySelector('[data-file-name]');
    this.fileRemove = this.querySelector('[data-file-remove]');

    this.file.addEventListener('change', this.handleChange.bind(this));
    this.fileRemove.addEventListener('click', this.handleRemove.bind(this));
  }

  handleChange(event) {
    const file = event.target.files[0];
    if (!file) return;
    this.classList.add('uploaded');
    this.style.backgroundImage = `url(${URL.createObjectURL(file)})`;
    this.fileName.value = file.name;
    const change = new Event('input');
    this.fileName.dispatchEvent(change);
    this.file.disabled = true;
  }

  handleRemove() {
    this.file.value = '';
    this.fileName.value = '';
    this.classList.remove('uploaded');
    this.style.backgroundImage = null;
    const change = new Event('input');
    this.fileName.dispatchEvent(change);
    this.file.disabled = false;
  }

  makeid() {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < 10; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
}

customElements.get('module-file') || customElements.define('module-file', ModuleFile);

